// unilar mobile collection layout toggle (grid vs horizontal list)
(function initunilarLayoutToggle() {
  const STORAGE_KEY = 'unilar-collection-layout';
  const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

  function getProductList() {
    return document.getElementById('unilar-product-list');
  }

  function getToggleTrack() {
    return document.querySelector('[data-unilar-layout-toggle] .unilar-layout-toggle__track');
  }

  function getToggleButtons() {
    return document.querySelectorAll('[data-unilar-layout-toggle] .unilar-layout-toggle__btn');
  }

  /**
   * @param {Element | null | undefined} view
   * @returns {Element | null}
   */
  function getWishlistWrapper(view) {
    return view?.querySelector('.Vtl-WishlistIcon__Wrapper') || null;
  }

  function syncWishlistIcons() {
    const productList = getProductList();
    if (!productList) return;

    const isListLayout = mobileMediaQuery.matches && productList.getAttribute('data-layout') === 'list';

    productList.querySelectorAll('.unilar-product-list-item').forEach((item) => {
      const gridView = item.querySelector('.unilar-product-card-view--grid');
      const listView = item.querySelector('.unilar-product-card-view--list');
      const targetView = isListLayout ? listView : gridView;
      const sourceView = isListLayout ? gridView : listView;
      const targetCard = targetView?.querySelector('product-card');

      if (!targetView || !sourceView || !targetCard || getWishlistWrapper(targetView)) return;

      const wishlistWrapper = getWishlistWrapper(sourceView);
      if (wishlistWrapper) {
        targetCard.appendChild(wishlistWrapper);
      }
    });
  }

  function getStoredLayout() {
    return sessionStorage.getItem(STORAGE_KEY) === 'list' ? 'list' : 'grid';
  }

  function setStoredLayout(layout) {
    sessionStorage.setItem(STORAGE_KEY, layout);
  }

  function applyLayout(layout, options = {}) {
    const { persist = true } = options;
    const productList = getProductList();
    const track = getToggleTrack();
    const buttons = getToggleButtons();
    if (!productList) return;

    const effectiveLayout = mobileMediaQuery.matches ? layout : 'grid';

    productList.setAttribute('data-layout', effectiveLayout);

    if (track) {
      track.setAttribute('data-layout', effectiveLayout);
    }

    buttons.forEach((btn) => {
      const isActive = btn.dataset.layout === effectiveLayout;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (persist && mobileMediaQuery.matches) {
      setStoredLayout(layout);
    }

    syncWishlistIcons();
  }

  function initLayoutToggle() {
    const buttons = getToggleButtons();
    if (!buttons.length) return;

    applyLayout(getStoredLayout(), { persist: false });

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const layout = btn.dataset.layout;
        const list = getProductList();
        if (!layout || !list) return;
        const current = list.getAttribute('data-layout') || 'grid';
        if (layout === current) return;
        applyLayout(layout);
      });
    });

    mobileMediaQuery.addEventListener('change', () => {
      applyLayout(getStoredLayout(), { persist: false });
    });

    const productList = getProductList();
    if (productList) {
      const wishlistObserver = new MutationObserver(() => {
        window.requestAnimationFrame(syncWishlistIcons);
      });

      wishlistObserver.observe(productList, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLayoutToggle);
  } else {
    initLayoutToggle();
  }

  window.unilarCollectionLayout = {
    applyLayout,
    getStoredLayout
  };
})();

// unilar AJAX Filters and Collection Controls
(function() {
  const filterTrigger = document.querySelector('.unilar-filter-trigger');
  const mobileFilterBtn = document.querySelector('.mobile-filter-btn');
  const filterDrawer = document.querySelector('.unilar-filter-drawer');
  const filterCloseBtn = document.querySelector('.filter-close-btn');
  const filterOverlay = document.querySelector('.filter-drawer-overlay');
  const filterForm = document.getElementById('unilar-filter-form');
  const clearFiltersBtn = document.getElementById('clear-filters-btn');
  const productList = document.getElementById('unilar-product-list');
  const pagination = document.getElementById('unilar-pagination');

  // Sort modal elements
  const mobileSortBtn = document.querySelector('.mobile-sort-btn');
  const sortModal = document.getElementById('unilar-sort-modal');
  const sortModalClose = document.querySelector('.sort-modal-close');
  const sortModalOverlay = document.querySelector('.sort-modal-overlay');
  const sortModalRadios = document.querySelectorAll('input[name="sort_by_modal"]');

  if (!filterDrawer || !filterForm) return;

  const filterStrings = {
    active_filters_title: filterForm.dataset.filtersActiveTitle || 'Filtros selecionados',
    clear_all: filterForm.dataset.filtersClearAll || 'Limpar tudo',
    apply_filters: filterForm.dataset.filtersApply || 'Aplicar filtros'
  };

  // Get section ID from the results-list element
  const resultsListElement = document.querySelector('results-list[section-id]');
  const sectionId = resultsListElement?.getAttribute('section-id');

  function getRenderedSectionRoot(fragment) {
    if (!fragment || !sectionId) return fragment;
    const raw = String(sectionId).replace(/^shopify-section-/, '');
    const esc =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(raw)
        : raw.replace(/([^\w-])/g, '\\$1');
    const wrapped = fragment.querySelector('#shopify-section-' + esc);
    return wrapped || fragment;
  }

  const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

  // Check if desktop (filters always visible as sidebar)
  function isDesktop() {
    return desktopMediaQuery.matches;
  }

  function syncFeaturedSizeFilterInputs(sectionRoot) {
    const currentComponent = document.getElementById('unilar-featured-size-filter');
    const nextComponent = sectionRoot.querySelector('#unilar-featured-size-filter');
    const referenceComponent = nextComponent || currentComponent;
    const referenceCard = referenceComponent?.querySelector('[data-featured-size-filter-card]');
    const paramName = referenceCard?.dataset.filterParamName;
    const nextForm = sectionRoot.querySelector('#unilar-filter-form');

    if (!paramName || !nextForm) return;

    const nextState = new Map();
    nextForm.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      if (input.name === paramName) {
        nextState.set(input.value, input.checked);
      }
    });

    filterForm.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      if (input.name === paramName) {
        input.checked = nextState.get(input.value) === true;
      }
    });
  }

  function updateFeaturedSizeFilter(sectionRoot) {
    const currentComponent = document.getElementById('unilar-featured-size-filter');
    const nextComponent = sectionRoot.querySelector('#unilar-featured-size-filter');

    if (currentComponent && nextComponent) {
      currentComponent.replaceWith(nextComponent);
      return;
    }

    if (currentComponent) {
      currentComponent.remove();
      return;
    }

    const contentWrapper = document.querySelector('.unilar-collection-content-wrapper');
    if (nextComponent && contentWrapper) {
      contentWrapper.before(nextComponent);
    }
  }

  // Drawer controls
  function openDrawer() {
    if (isDesktop()) return;
    filterDrawer.setAttribute('aria-hidden', 'false');
    if (filterTrigger) filterTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (isDesktop()) return;
    filterDrawer.setAttribute('aria-hidden', 'true');
    if (filterTrigger) filterTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  // Initialize drawer state based on viewport
  function initDrawerState() {
    if (isDesktop()) {
      filterDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = '';
    } else {
      filterDrawer.setAttribute('aria-hidden', 'true');
      if (filterTrigger) filterTrigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  }

  // Initialize on load
  initDrawerState();

  // Re-sync after full load (mobile browsers may report viewport size late)
  window.addEventListener('load', initDrawerState);

  // Restore drawer state when returning via back/forward cache
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) initDrawerState();
  });

  desktopMediaQuery.addEventListener('change', initDrawerState);

  // Filter drawer controls
  filterTrigger?.addEventListener('click', openDrawer);
  mobileFilterBtn?.addEventListener('click', openDrawer);
  filterCloseBtn?.addEventListener('click', closeDrawer);
  filterOverlay?.addEventListener('click', closeDrawer);

  // Sort modal controls
  function openSortModal() {
    if (sortModal) {
      sortModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeSortModal() {
    if (sortModal) {
      sortModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  mobileSortBtn?.addEventListener('click', openSortModal);
  sortModalClose?.addEventListener('click', closeSortModal);
  sortModalOverlay?.addEventListener('click', closeSortModal);

  // Handle sort selection in modal
  sortModalRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        const sortValue = radio.value;
        
        // Update desktop select if exists
        const desktopSelect = document.getElementById('unilar-sort-select');
        if (desktopSelect) {
          desktopSelect.value = sortValue;
        }
        
        syncunilarManualRangeInputs(filterForm);
        const filterParams = getFormData();
        
        // Build URL with both filters and sort
        const url = new URL(window.location.href);
        url.search = ''; // Clear existing params
        
        // Add filter params
        if (filterParams) {
          const params = new URLSearchParams(filterParams);
          params.forEach((value, key) => {
            url.searchParams.append(key, value);
          });
        }
        
        // Add sort param
        url.searchParams.set('sort_by', sortValue);
        
        // Apply with combined parameters
        applyFilters(url.search);
        
        // Close modal
        closeSortModal();
      }
    });
  });

  // Close on Escape key (mobile only)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (!isDesktop() && filterDrawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
      if (sortModal && sortModal.getAttribute('aria-hidden') === 'false') {
        closeSortModal();
      }
    }
  });

  // AJAX Filter functionality
  let debounceTimers = {};
  
  function debounce(func, delay, key = 'default') {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(func, delay);
  }

  class unilarPriceRange extends HTMLElement {
    constructor() {
      super();
      /** @type {HTMLInputElement | null} */
      this.rangeMin = null;
      /** @type {HTMLInputElement | null} */
      this.rangeMax = null;
      /** @type {HTMLInputElement | null} */
      this.valueMin = null;
      /** @type {HTMLInputElement | null} */
      this.valueMax = null;
      /** @type {HTMLElement | null} */
      this.displayMin = null;
      /** @type {HTMLElement | null} */
      this.displayMax = null;
      /** @type {HTMLInputElement | null} */
      this.manualMin = null;
      /** @type {HTMLInputElement | null} */
      this.manualMax = null;
      /** @type {HTMLElement | null} */
      this.rangeBar = null;
      this.currencySymbol = 'R$';
      this.originalMinName = '';
      this.originalMaxName = '';
    }

    connectedCallback() {
      this.rangeMin = /** @type {HTMLInputElement | null} */ (this.querySelector('#range-min'));
      this.rangeMax = /** @type {HTMLInputElement | null} */ (this.querySelector('#range-max'));
      this.valueMin = /** @type {HTMLInputElement | null} */ (this.querySelector('#min-price'));
      this.valueMax = /** @type {HTMLInputElement | null} */ (this.querySelector('#max-price'));
      this.displayMin = /** @type {HTMLElement | null} */ (this.querySelector('#min-price-display'));
      this.displayMax = /** @type {HTMLElement | null} */ (this.querySelector('#max-price-display'));
      this.manualMin = /** @type {HTMLInputElement | null} */ (this.querySelector('.unilar-range-manual-min'));
      this.manualMax = /** @type {HTMLInputElement | null} */ (this.querySelector('.unilar-range-manual-max'));
      this.rangeBar = /** @type {HTMLElement | null} */ (this.querySelector('.range-bar'));
      this.currencySymbol = this.dataset.currencySymbol || 'R$';

      if (!this.rangeMin || !this.rangeMax) return;

      this.originalMinName = this.rangeMin.getAttribute('name') || '';
      this.originalMaxName = this.rangeMax.getAttribute('name') || '';

      this.rangeMin.addEventListener('input', () => this.handleRangeInput(this.rangeMin));
      this.rangeMax.addEventListener('input', () => this.handleRangeInput(this.rangeMax));
      this.rangeMin.addEventListener('change', () => this.handleRangeChange());
      this.rangeMax.addEventListener('change', () => this.handleRangeChange());

      this.manualMin?.addEventListener('input', () => this.handleManualInput());
      this.manualMax?.addEventListener('input', () => this.handleManualInput());
      this.manualMin?.addEventListener('change', () => this.handleManualChange());
      this.manualMax?.addEventListener('change', () => this.handleManualChange());

      this.updateUI();
    }

    getMinLimit() {
      return Number.parseFloat(this.rangeMin?.getAttribute('min') || '0') || 0;
    }

    getMaxLimit() {
      return Number.parseFloat(this.rangeMax?.getAttribute('max') || '0') || 0;
    }

    getStep() {
      return Number.parseFloat(this.rangeMin?.getAttribute('step') || '0.01') || 0.01;
    }

    /**
     * @param {HTMLInputElement | null} input
     * @param {number} [fallback]
     */
    getNumber(input, fallback = 0) {
      if (!input) return fallback;
      const parsed = Number.parseFloat(String(input.value).replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    /**
     * @param {number} value
     * @param {number} min
     * @param {number} max
     */
    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    /**
     * @param {number} value
     */
    normalizeValue(value) {
      const step = this.getStep();
      const decimalPart = String(step).split('.')[1] || '';
      const decimals = decimalPart.length;
      return Number(value).toFixed(decimals);
    }

    /**
     * @param {number | string} value
     */
    formatMoney(value) {
      const formatted = Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return `${this.currencySymbol} ${formatted}`;
    }

    /**
     * @param {HTMLInputElement | null} changedInput
     */
    handleRangeInput(changedInput) {
      if (!this.rangeMin || !this.rangeMax) return;

      const minLimit = this.getMinLimit();
      const maxLimit = this.getMaxLimit();
      let min = this.getNumber(this.rangeMin, minLimit);
      let max = this.getNumber(this.rangeMax, maxLimit);

      if (min > max) {
        if (changedInput === this.rangeMin) {
          min = max;
          this.rangeMin.value = this.normalizeValue(min);
        } else {
          max = min;
          this.rangeMax.value = this.normalizeValue(max);
        }
      }

      this.updateUI();
      updateFilterCount();
    }

    handleRangeChange() {
      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 500, 'price');
      }
    }

    handleManualInput() {
      if (!this.rangeMin || !this.rangeMax) return;

      const minLimit = this.getMinLimit();
      const maxLimit = this.getMaxLimit();
      const min = this.clamp(this.getNumber(this.manualMin, minLimit), minLimit, maxLimit);
      const max = this.clamp(this.getNumber(this.manualMax, maxLimit), minLimit, maxLimit);

      if (Number.isFinite(min)) this.rangeMin.value = this.normalizeValue(Math.min(min, max));
      if (Number.isFinite(max)) this.rangeMax.value = this.normalizeValue(Math.max(min, max));

      this.updateUI({ updateManualInputs: false });
      updateFilterCount();
    }

    handleManualChange() {
      this.applyManualValuesBeforeSubmit();
      updateFilterCount();

      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 500, 'price');
      }
    }

    /**
     * @param {{ updateManualInputs?: boolean }} [options]
     */
    updateUI(options = {}) {
      if (!this.rangeMin || !this.rangeMax) return;

      const { updateManualInputs = true } = options;
      const minLimit = this.getMinLimit();
      const maxLimit = this.getMaxLimit();
      const min = this.clamp(this.getNumber(this.rangeMin, minLimit), minLimit, maxLimit);
      const max = this.clamp(this.getNumber(this.rangeMax, maxLimit), minLimit, maxLimit);

      this.rangeMin.value = this.normalizeValue(Math.min(min, max));
      this.rangeMax.value = this.normalizeValue(Math.max(min, max));

      if (this.valueMin) this.valueMin.value = this.rangeMin.value;
      if (this.valueMax) this.valueMax.value = this.rangeMax.value;
      if (updateManualInputs && this.manualMin) this.manualMin.value = this.rangeMin.value;
      if (updateManualInputs && this.manualMax) this.manualMax.value = this.rangeMax.value;
      if (this.displayMin) this.displayMin.textContent = this.formatMoney(this.rangeMin.value);
      if (this.displayMax) this.displayMax.textContent = this.formatMoney(this.rangeMax.value);

      if (this.rangeBar && maxLimit > minLimit) {
        const left = ((Number(this.rangeMin.value) - minLimit) / (maxLimit - minLimit)) * 100;
        const right = 100 - ((Number(this.rangeMax.value) - minLimit) / (maxLimit - minLimit)) * 100;
        this.rangeBar.style.left = `${left}%`;
        this.rangeBar.style.right = `${right}%`;
      }
    }

    applyManualValuesBeforeSubmit() {
      if (!this.rangeMin || !this.rangeMax) return;

      const minLimit = this.getMinLimit();
      const maxLimit = this.getMaxLimit();
      const manualMin = this.getNumber(this.manualMin, this.getNumber(this.rangeMin, minLimit));
      const manualMax = this.getNumber(this.manualMax, this.getNumber(this.rangeMax, maxLimit));
      const min = this.clamp(Math.min(manualMin, manualMax), minLimit, maxLimit);
      const max = this.clamp(Math.max(manualMin, manualMax), minLimit, maxLimit);

      this.rangeMin.value = this.normalizeValue(min);
      this.rangeMax.value = this.normalizeValue(max);
      this.updateUI();
    }

    suppressFullRangePriceParams() {
      if (!this.rangeMin || !this.rangeMax) return;

      this.restorePriceRangeInputNames();

      const minLimit = this.getMinLimit();
      const maxLimit = this.getMaxLimit();
      const min = this.getNumber(this.rangeMin, minLimit);
      const max = this.getNumber(this.rangeMax, maxLimit);

      if (min <= minLimit) this.rangeMin.removeAttribute('name');
      if (max >= maxLimit) this.rangeMax.removeAttribute('name');
    }

    restorePriceRangeInputNames() {
      if (this.originalMinName) this.rangeMin?.setAttribute('name', this.originalMinName);
      if (this.originalMaxName) this.rangeMax?.setAttribute('name', this.originalMaxName);
    }

    resetFilterToDefault() {
      if (!this.rangeMin || !this.rangeMax) return;

      this.restorePriceRangeInputNames();

      const minLimit = this.getMinLimit();
      const maxLimit = this.getMaxLimit();
      this.rangeMin.value = this.normalizeValue(minLimit);
      this.rangeMax.value = this.normalizeValue(maxLimit);
      this.updateUI();
    }
  }

  if (!customElements.get('price-range')) {
    customElements.define('price-range', unilarPriceRange);
  }

  function restorePriceRangeInputNames(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.restorePriceRangeInputNames === 'function') {
        el.restorePriceRangeInputNames();
      }
    });
  }

  function getFormData() {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams();
    
    for (const [key, value] of formData.entries()) {
      if (value) {
        params.append(key, value);
      }
    }
    
    const q = params.toString();
    restorePriceRangeInputNames(filterForm);
    return q;
  }

  function syncunilarManualRangeInputs(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.applyManualValuesBeforeSubmit === 'function') {
        el.applyManualValuesBeforeSubmit();
      }
      if (typeof el.suppressFullRangePriceParams === 'function') {
        el.suppressFullRangePriceParams();
      }
    });
    form.querySelectorAll('list-range').forEach((el) => {
      if (typeof el.applyManualValuesBeforeSubmit === 'function') {
        el.applyManualValuesBeforeSubmit();
      }
    });
  }

  function resetAllunilarRangeWidgets(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.resetFilterToDefault === 'function') {
        el.resetFilterToDefault();
      }
    });
    form.querySelectorAll('list-range').forEach((el) => {
      if (typeof el.resetFilterToDefault === 'function') {
        el.resetFilterToDefault();
      }
    });
  }

  function getSearchClearApplyQuery() {
    const raw = filterForm?.dataset?.searchClearUrl;
    if (!raw || String(raw).trim() === '') return null;
    try {
      const clearUrl = new URL(raw, window.location.href);
      const next = new URLSearchParams(clearUrl.search);
      let currentSort = null;
      try {
        currentSort = new URL(window.location.href).searchParams.get('sort_by');
      } catch (e) {
        currentSort = null;
      }
      if (currentSort) {
        next.set('sort_by', currentSort);
      }
      const s = next.toString();
      return s ? `?${s}` : '?';
    } catch (e) {
      return null;
    }
  }

  function updateURL(params) {
    const baseUrl = filterForm.dataset.collectionUrl;
    const newUrl = params ? `${baseUrl}?${params}` : baseUrl;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }

  function showLoading() {
    const applyBtn = filterForm.querySelector('.filter-footer-apply');
    const applyText = applyBtn?.querySelector('.filter-apply-text');
    const loadingIcon = applyBtn?.querySelector('.filter-loading');
    
    if (applyText) applyText.style.display = 'none';
    if (loadingIcon) loadingIcon.style.display = 'inline-block';
    if (applyBtn) applyBtn.disabled = true;
    
    if (productList) {
      productList.style.opacity = '0.5';
      productList.style.pointerEvents = 'none';
    }
  }

  function hideLoading() {
    const applyBtn = filterForm.querySelector('.filter-footer-apply');
    const applyText = applyBtn?.querySelector('.filter-apply-text');
    const loadingIcon = applyBtn?.querySelector('.filter-loading');
    
    if (applyText) applyText.style.display = 'inline';
    if (loadingIcon) loadingIcon.style.display = 'none';
    if (applyBtn) applyBtn.disabled = false;
    
    if (productList) {
      productList.style.opacity = '1';
      productList.style.pointerEvents = 'all';
    }
  }

  async function applyFilters(customParams = null, options = {}) {
    const { updateHistory = true } = options;
    syncunilarManualRangeInputs(filterForm);
    showLoading();
    
    const params = customParams || getFormData();
    if (customParams) {
      restorePriceRangeInputNames(filterForm);
    }
    const baseUrl = filterForm.dataset.collectionUrl;
    let url;
    
    if (customParams) {
      // customParams already includes '?' prefix
      url = `${baseUrl}${params}&section_id=${sectionId}`;
    } else {
      // getFormData() returns params without '?' prefix
      url = params ? `${baseUrl}?${params}&section_id=${sectionId}` : `${baseUrl}?section_id=${sectionId}`;
    }

    try {
      const response = await fetch(url);
      const html = await response.text();
      
      // Create temporary container to parse response
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const sectionRoot = getRenderedSectionRoot(tempDiv);

      syncFeaturedSizeFilterInputs(sectionRoot);
      updateFeaturedSizeFilter(sectionRoot);

      // Update active filters section
      const activeFiltersContainer = document.getElementById('unilar-active-filters');
      const newActiveFilters = sectionRoot.querySelector('#unilar-active-filters');
      
      if (activeFiltersContainer) {
        if (newActiveFilters) {
          // Server returned updated active filters
          activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
        } else {
          // Server didn't return active filters (first selection), build it manually
          const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]:checked');
          const priceInputs = filterForm.querySelectorAll('.filter-price-input');
          const hasFilters = checkboxes.length > 0 || Array.from(priceInputs).some(input => input.value);
          
          if (hasFilters) {
            // Build active filters HTML
            let activeFiltersHTML = '<div class="filter-active-section">';
            activeFiltersHTML += '<h5 class="filter-active-title">' + filterStrings.active_filters_title + '</h5>';
            activeFiltersHTML += '<div class="filter-active-list">';
            
            // Add checkbox filters
            checkboxes.forEach(checkbox => {
              const label = checkbox.closest('.filter-item')?.querySelector('.filter-label')?.textContent || checkbox.value;
              const filterGroup = checkbox.closest('.filter-group')?.querySelector('.filter-group-title')?.textContent || '';
              activeFiltersHTML += `
                <button type="button" class="filter-active-tag" data-filter-value="${checkbox.value}">
                  <span>${filterGroup}: ${label}</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12M4 4L12 12" stroke="#A4ADA8" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </button>
              `;
            });
            
            const clearHref =
              filterForm.dataset.searchClearUrl || filterForm.dataset.collectionUrl || '';
            activeFiltersHTML += '</div>';
            activeFiltersHTML +=
              '<a href="' + clearHref + '" class="filter-clear-all">' + filterStrings.clear_all + '</a>';
            activeFiltersHTML += '</div>';
            
            activeFiltersContainer.innerHTML = activeFiltersHTML;
            
            // Add event listeners to remove individual filters
            activeFiltersContainer.querySelectorAll('.filter-active-tag').forEach(tag => {
              tag.addEventListener('click', () => {
                const filterValue = tag.dataset.filterValue;
                const checkbox = filterForm.querySelector(`input[value="${filterValue}"]`);
                if (checkbox) {
                  checkbox.checked = false;
                  applyFilters();
                }
              });
            });
          } else {
            activeFiltersContainer.innerHTML = '';
          }
        }
      }
      
      // Update filter header badge
      const filterHeaderBadge = document.querySelector('.filter-header-content .filter-count-badge');
      const newFilterHeader = sectionRoot.querySelector('.filter-header-content');
      const newHeaderBadge = newFilterHeader?.querySelector('.filter-count-badge');
      if (filterHeaderBadge && newHeaderBadge) {
        filterHeaderBadge.textContent = newHeaderBadge.textContent;
        filterHeaderBadge.style.display = 'flex';
      } else if (filterHeaderBadge && !newHeaderBadge) {
        filterHeaderBadge.style.display = 'none';
      } else if (!filterHeaderBadge && newHeaderBadge) {
        // Add badge if it doesn't exist
        const headerContent = document.querySelector('.filter-header-content');
        if (headerContent) {
          const badge = document.createElement('span');
          badge.className = 'filter-count-badge';
          badge.textContent = newHeaderBadge.textContent;
          headerContent.appendChild(badge);
        }
      }

      const newTriggerBadge = sectionRoot.querySelector('.unilar-filter-trigger .filter-count-badge');
      const triggerBadge = document.querySelector('.unilar-filter-trigger .filter-count-badge');
      if (triggerBadge) {
        if (newTriggerBadge) {
          triggerBadge.textContent = newTriggerBadge.textContent;
          triggerBadge.style.display = '';
        } else {
          triggerBadge.style.display = 'none';
        }
      }

      // Sync per-group orange count badges (ex.: Marca, Faixas de preço)
      syncFilterGroupCounts(sectionRoot);

      const newCountHighlight = sectionRoot.querySelector('.unilar-collection-count .count-highlight');
      const countHighlight = document.querySelector('.unilar-collection-count .count-highlight');
      if (newCountHighlight && countHighlight) {
        countHighlight.textContent = newCountHighlight.textContent;
      }
      
      // Update product list
      const newProductList = sectionRoot.querySelector('#unilar-product-list');
      if (newProductList && productList) {
        productList.innerHTML = newProductList.innerHTML;
        window.unilarCollectionLayout?.applyLayout(
          window.unilarCollectionLayout.getStoredLayout(),
          { persist: false }
        );
        if (productList.closest('.unilar-search-results')) {
          productList.dispatchEvent(new CustomEvent('unilar:search-list-refresh', { bubbles: false }));
        }
      }
      
      // Update pagination
      const newPagination = sectionRoot.querySelector('#unilar-pagination');
      if (pagination) {
        if (newPagination) {
          pagination.innerHTML = newPagination.innerHTML;
          pagination.style.display = '';
        } else {
          pagination.style.display = 'none';
        }
      }
      
      // Update URL
      if (updateHistory) {
        if (customParams) {
          window.history.pushState({}, '', baseUrl + customParams);
        } else {
          updateURL(params);
        }
      }
      
      // Contador vem do HTML da section (total_active_filters). Não chamar updateFilterCount()
      // aqui — ele somava todos os checkboxes, inclusive os ocultos do list-range (ex.: 187).
      
      // Scroll to top of product list
      productList?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
    } catch (error) {
      console.error('Error applying filters:', error);
    } finally {
      hideLoading();
    }
  }

  function syncFilterGroupCounts(sectionRoot) {
    if (!filterForm || !sectionRoot) return;

    const liveGroups = filterForm.querySelectorAll('.filter-group');
    const nextGroups = sectionRoot.querySelectorAll('.filter-group');
    const nextByTitle = new Map();

    nextGroups.forEach((group) => {
      const title = group.querySelector('.filter-group-title')?.textContent?.trim();
      if (title) nextByTitle.set(title, group);
    });

    liveGroups.forEach((group) => {
      const titleEl = group.querySelector('.filter-group-title');
      const title = titleEl?.textContent?.trim();
      if (!titleEl || !title) return;

      const nextGroup = nextByTitle.get(title);
      const nextBadge = nextGroup?.querySelector('.filter-group-count');
      let badge = group.querySelector('.filter-group-count');

      if (nextBadge) {
        const countText = nextBadge.textContent.trim();
        if (badge) {
          badge.textContent = countText;
          badge.hidden = false;
          badge.style.display = '';
        } else {
          badge = document.createElement('span');
          badge.className = 'filter-group-count';
          badge.textContent = countText;
          titleEl.insertAdjacentElement('afterend', badge);
        }
        group.open = true;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function updateFilterCount() {
    let count = 0;
    filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
      if (cb.closest('.list-range-hidden-values')) return;
      count++;
    });

    filterForm.querySelectorAll('list-range').forEach((lr) => {
      const minR = lr.querySelector('#range-min');
      const maxR = lr.querySelector('#range-max');
      if (!minR || !maxR) return;
      const minV = parseInt(minR.value, 10);
      const maxV = parseInt(maxR.value, 10);
      const lo = parseInt(minR.getAttribute('min') || '0', 10);
      const hi = parseInt(maxR.getAttribute('max') || '0', 10);
      if (minV > lo || maxV < hi) {
        count++;
      }
    });

    filterForm.querySelectorAll('price-range').forEach((priceRange) => {
      const minR = priceRange.querySelector('#range-min');
      const maxR = priceRange.querySelector('#range-max');
      if (!minR || !maxR) return;
      const minV = parseFloat(minR.value || '0');
      const maxV = parseFloat(maxR.value || '0');
      const lo = parseFloat(minR.getAttribute('min') || '0');
      const hi = parseFloat(maxR.getAttribute('max') || '0');
      if (minV > lo || maxV < hi) {
        count++;
      }
    });
    
    // Update badges
    const badges = document.querySelectorAll('.filter-count-badge');
    badges.forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
    
    // Update apply button text
    const applyText = filterForm.querySelector('.filter-apply-text');
    if (applyText) {
      applyText.textContent = filterStrings.apply_filters;
    }
  }

  // Form submission
  filterForm.addEventListener('submit', (e) => {
    e.preventDefault();
    applyFilters();
    if (!isDesktop()) {
      closeDrawer();
    }
  });

  // Auto-apply on checkbox change (desktop only)
  filterForm.addEventListener('change', (e) => {
    if (e.target.classList.contains('filter-input') && e.target.type === 'checkbox') {
      updateFilterCount();
      // Auto-submit on checkbox change for desktop
      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 300, 'checkbox');
      }
    }
  });

  // Auto-apply on price input change
  const priceInputs = filterForm.querySelectorAll('.filter-price-input');
  priceInputs.forEach((input, index) => {
    input.addEventListener('input', () => {
      updateFilterCount();
      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 800, 'price');
      }
    });
  });

  // Clear filters
  clearFiltersBtn?.addEventListener('click', () => {
    resetAllunilarRangeWidgets(filterForm);

    const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((cb) => {
      cb.checked = false;
    });

    const priceInputs = filterForm.querySelectorAll('.filter-price-input');
    priceInputs.forEach((input) => {
      input.value = '';
    });

    const searchOnlyClear = getSearchClearApplyQuery();
    if (searchOnlyClear != null) {
      applyFilters(searchOnlyClear);
    } else {
      applyFilters();
    }

    updateFilterCount();

    if (!isDesktop()) {
      closeDrawer();
    }
  });

  // Handle active filter tag removals
  document.addEventListener('click', (e) => {
    if (e.target.closest('.filter-active-tag')) {
      e.preventDefault();
      const link = e.target.closest('.filter-active-tag');
      
      // Find and uncheck the corresponding checkbox
      const href = link.getAttribute('href');
      if (href) {
        window.location.href = href; // For now, use direct navigation
      }
    }
  });

  // Initialize filter count on page load
  updateFilterCount();

  resultsListElement?.addEventListener('click', (event) => {
    const eventTarget = event.target instanceof Element ? event.target : null;
    const card = eventTarget?.closest('[data-featured-size-filter-card]');
    if (!card || !resultsListElement.contains(card)) return;

    event.preventDefault();

    const component = card.closest('#unilar-featured-size-filter');
    const clearUrl = component?.dataset.filterClearUrl;
    const paramName = card.dataset.filterParamName;
    const filterValue = card.dataset.filterValue;
    const isActive = card.dataset.filterActive === 'true';

    if (!component || !clearUrl || !paramName || !filterValue) return;

    const targetUrl = new URL(clearUrl, window.location.href);
    targetUrl.searchParams.delete('section_id');
    targetUrl.searchParams.delete(paramName);

    if (!isActive) {
      targetUrl.searchParams.append(paramName, filterValue);
    }

    component.setAttribute('aria-busy', 'true');
    component.querySelectorAll('[data-featured-size-filter-card]').forEach((button) => {
      button.disabled = true;
    });

    applyFilters(targetUrl.search || '?').finally(() => {
      if (!component.isConnected) return;

      component.removeAttribute('aria-busy');
      component.querySelectorAll('[data-featured-size-filter-card]').forEach((button) => {
        button.disabled = false;
      });
    });
  });

  window.addEventListener('popstate', () => {
    applyFilters(window.location.search || '?', { updateHistory: false });
  });

  // Sort functionality
  const sortSelect = document.getElementById('unilar-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const sortValue = sortSelect.value;
      
      syncunilarManualRangeInputs(filterForm);
      const filterParams = getFormData();
      
      // Build URL with both filters and sort
      const url = new URL(window.location.href);
      url.search = ''; // Clear existing params
      
      // Add filter params
      if (filterParams) {
        const params = new URLSearchParams(filterParams);
        params.forEach((value, key) => {
          url.searchParams.append(key, value);
        });
      }
      
      // Add sort param
      url.searchParams.set('sort_by', sortValue);
      
      // Apply with combined parameters
      applyFilters(url.search);
    });
  }
})();
